import { BASE_URL_LEGACY } from "./";

export const feedbackService = {
  submitFeedback,
};

function submitFeedback(user, values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: `user_id=${user}&feedback=${values.feedback}`,
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/common/feedback/`, requestOptions)
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}
